import * as types from "../utils/ActionTypes";

export function storeUserInfo(premise) {
    return {
        type: types.ADD_USER_INFO,
        payload: premise
    }
}

export function clearUserInfo() {
    return {
        type: types.CLEAR_USER_INFO
    }
}